import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section
      className="bg-cover bg-center text-white relative"
      style={{
        backgroundColor: '#4a5f7f',
        backgroundImage: `url('/img/background_trabbit.webp')`,
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
      <div className="container mx-auto px-4 py-16 md:py-24 flex items-center relative z-10">
        <div className="md:w-1/2">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}
          >
            {t('hero.title')}
          </h2>
          <p
            className="text-lg mb-8"
            style={{ textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}
          >
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <a
              href="#contact"
              className="bg-white text-purple-600 font-bold py-3 px-6 rounded-lg shadow-lg hover:bg-gray-100 transition duration-300 text-center"
            >
              {t('hero.ctaPrimary')}
            </a>
            <a
              href="#services"
              className="bg-transparent border-2 border-white text-white font-bold py-3 px-6 rounded-lg hover:bg-white hover:text-purple-600 transition duration-300 text-center"
            >
              {t('hero.ctaSecondary')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
